module.exports = __webpack_public_path__ + "img/contact.265fb450.svg";